import { render, staticRenderFns } from "./create_menu.vue.js?vue&type=template&id=d51ed82c&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create_menu.vue?vue&type=template&id=d51ed82c&vue3"
import script from "./create_menu.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create_menu.vue?vue&type=script&lang=js&vue3"
export * from "./create_menu.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create_menu.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports